
import { Region } from '../../environment/region';

export enum PromoEngineEffect {
  StagedNotEligible = 'StagedNotEligible',
}

// Keep in sync with the RAFStagedEligible country setting.
export const RAF_STAGED_INELIGIBLE_REGIONS: Region[] = [Region.CL, Region.MY];

export interface IPromotionObject {
    isPromoBonus: boolean;
    isPromoDiscount: boolean;
    isSendingAmountDiscount: boolean;
    promoBonusAmount: number;
    promoDiscountAmount: number;
    isPromoTypeReferral: boolean;
  }


// WEBPACK FOOTER //
// ./src/model/types/promotionobject-type.ts